import DebugConsole from './DebugConsole';

export default DebugConsole;
